import { render, staticRenderFns } from "./NewIntegrationTable.vue?vue&type=template&id=6b40da7f&scoped=true&"
import script from "./NewIntegrationTable.vue?vue&type=script&lang=ts&"
export * from "./NewIntegrationTable.vue?vue&type=script&lang=ts&"
import style0 from "./NewIntegrationTable.vue?vue&type=style&index=0&id=6b40da7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b40da7f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VBtn,VChip,VDataTable,VForm,VIcon,VTextField,VTooltip})
